import apiClient from '@/shared/api/client'
import type { SupplierCategory, ItemCategory, ItemVendor, ItemSubType } from '@/shared/types/categories'

export const supplierCategoriesApi = {
  list: async (onlyActive = true): Promise<SupplierCategory[]> => {
    const res = await apiClient.get<SupplierCategory[]>('/supplier-categories', {
      params: { only_active: onlyActive },
    })
    return res.data
  },
  create: async (data: { code: string; name: string }): Promise<SupplierCategory> => {
    const res = await apiClient.post<SupplierCategory>('/supplier-categories', data)
    return res.data
  },
  update: async (id: string, data: Partial<SupplierCategory>): Promise<SupplierCategory> => {
    const res = await apiClient.patch<SupplierCategory>(`/supplier-categories/${id}`, data)
    return res.data
  },
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/supplier-categories/${id}`)
  },
}

export const itemCategoriesApi = {
  list: async (onlyActive = true): Promise<ItemCategory[]> => {
    const res = await apiClient.get<ItemCategory[]>('/item-categories', {
      params: { only_active: onlyActive },
    })
    return res.data
  },
  create: async (data: { code: string; name: string; sub_type?: ItemSubType }): Promise<ItemCategory> => {
    const res = await apiClient.post<ItemCategory>('/item-categories', data)
    return res.data
  },
  update: async (id: string, data: Partial<ItemCategory>): Promise<ItemCategory> => {
    const res = await apiClient.patch<ItemCategory>(`/item-categories/${id}`, data)
    return res.data
  },
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/item-categories/${id}`)
  },
}

export const itemVendorsApi = {
  list: async (itemId: string): Promise<ItemVendor[]> => {
    const res = await apiClient.get<ItemVendor[]>(`/items/${itemId}/vendors`)
    return res.data
  },
  add: async (itemId: string, data: Partial<ItemVendor>): Promise<ItemVendor> => {
    const res = await apiClient.post<ItemVendor>(`/items/${itemId}/vendors`, data)
    return res.data
  },
  update: async (ivId: string, data: Partial<ItemVendor>): Promise<ItemVendor> => {
    const res = await apiClient.patch<ItemVendor>(`/item-vendors/${ivId}`, data)
    return res.data
  },
  remove: async (ivId: string): Promise<void> => {
    await apiClient.delete(`/item-vendors/${ivId}`)
  },
}

export const itemDocumentsApi = {
  upload: async (itemId: string, docType: string, file: File) => {
    const fd = new FormData()
    fd.append('file', file)
    const res = await apiClient.post(`/items/${itemId}/documents/${docType}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return res.data
  },
  getUrl: (itemId: string, docType: string) =>
    `/api/v1/items/${itemId}/documents/${docType}`,
}
